import { format as _format, addDays, addMonths, addWeeks, addYears, endOfMonth, getDay, getDaysInMonth, setDate, startOfMonth, subDays, subMonths, subWeeks, subYears } from 'date-fns';
import { enGB, it } from 'date-fns/locale';
import chunk from 'lodash.chunk';
import { useContext } from 'react';
import { InternalCalendarDateContext, LocaleContext, UserSelectedDateContext } from './contexts';
const calculateDay = (date) => {
    const day = getDay(date);
    return day === 0 ? 7 : day;
};
export const useCalendarManager = () => {
    const locale = useContext(LocaleContext);
    const internalCalendarDate = useContext(InternalCalendarDateContext);
    const userSelectedDate = useContext(UserSelectedDateContext);
    return {
        locale,
        internalCalendarDate: internalCalendarDate.date,
        userSelectedDate: userSelectedDate.date,
        setDate: (date) => userSelectedDate.setDate(date),
        format: (date, format = 'dd MMM yyyy') => _format(date, format, {
            locale: locale === 'it' ? it : enGB
        }),
        months: {
            start: () => startOfMonth(internalCalendarDate.date),
            end: () => endOfMonth(internalCalendarDate.date),
            previous: () => internalCalendarDate.setDate(subMonths(internalCalendarDate.date, 1)),
            next: () => internalCalendarDate.setDate(addMonths(internalCalendarDate.date, 1)),
            get: () => {
                const days = getDaysInMonth(internalCalendarDate.date);
                const weekStart = calculateDay(startOfMonth(internalCalendarDate.date)) - 1;
                const weekEnd = calculateDay(endOfMonth(internalCalendarDate.date));
                const month = chunk([
                    ...Array.from({ length: weekStart }).fill(null),
                    ...Array.from({ length: days }, (_, i) => setDate(internalCalendarDate.date, i + 1)),
                    ...Array.from({ length: (6 - weekEnd) }).fill(null)
                ], 7);
                return month;
            }
        },
        years: {
            previous: () => subYears(internalCalendarDate.date, 1),
            next: () => addYears(internalCalendarDate.date, 1),
        },
        weeks: {
            previous: () => subWeeks(internalCalendarDate.date, 1),
            next: () => addWeeks(internalCalendarDate.date, 1),
        },
        days: {
            list: () => {
                const daysOfTheWeek = {
                    'en': [
                        { title: 'Monday', abbr: 'Mon' },
                        { title: 'Tuesday', abbr: 'Tue' },
                        { title: 'Wednesday', abbr: 'Wed' },
                        { title: 'Thursday', abbr: 'Thu' },
                        { title: 'Friday', abbr: 'Fri' },
                        { title: 'Saturday', abbr: 'Sat' },
                        { title: 'Sunday', abbr: 'Sun' }
                    ],
                    'it': [
                        { title: 'Lunedì', abbr: 'Lun' },
                        { title: 'Martedì', abbr: 'Mar' },
                        { title: 'Mercoledì', abbr: 'Mer' },
                        { title: 'Giovedì', abbr: 'Gio' },
                        { title: 'Venerdì', abbr: 'Ven' },
                        { title: 'Sabato', abbr: 'Sab' },
                        { title: 'Domenica', abbr: 'Dom' }
                    ]
                };
                return daysOfTheWeek[locale];
            },
            previous: (date) => subDays(date, 1),
            next: (date) => addDays(date, 1),
        }
    };
};
